import { Chip } from '@pets-ui/Chip/Chip'
import { Fade } from '@pets-ui/Fade/Fade'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'
import { useTranslation } from 'react-i18next'
import cartUiI18nInstance from '../i18n/i18nConfig'

const baseStyles = stylex.create({
  chip: {
    backgroundColor: colors.green500,
    color: colors.white,
    position: 'absolute',
    transform: 'translate(1em, -50%)',
    right: 0,
    top: 0,
  },
})

export interface ChipFreeShippingProps {
  shippingFee: number
  rootStyle?: stylex.StyleXStyles
  isCartEmpty?: boolean
}

export const ChipFreeShipping = (props: ChipFreeShippingProps) => {
  const { shippingFee, rootStyle, isCartEmpty } = props
  const { t } = useTranslation('cartUi', { i18n: cartUiI18nInstance })
  return (
    <Fade in={shippingFee === 0 && !isCartEmpty}>
      <Chip size="xSmall" color="green" variant="square" rootStyle={[baseStyles.chip, rootStyle]}>
        {t('cartUi.freeShipping', { defaultValue: '免運費' })}
      </Chip>
    </Fade>
  )
}
